module.exports = __webpack_public_path__ + "img/undraw_Around_the_world_re_n353.a9254b3d.svg";